import { render, staticRenderFns } from "./ConsoleBimModel.vue?vue&type=template&id=0d63c993&scoped=true"
import script from "./ConsoleBimModel.vue?vue&type=script&lang=js"
export * from "./ConsoleBimModel.vue?vue&type=script&lang=js"
import style0 from "./ConsoleBimModel.vue?vue&type=style&index=0&id=0d63c993&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d63c993",
  null
  
)

export default component.exports